export const categories = [
  {
    id: 'outdoor',
    name: '户外运动',
    slug: 'outdoor',
    description: '徒步、登山、骑行、露营等户外探险活动，让我们一起拥抱大自然',
    icon: 'ri-landscape-line',
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20Chinese%20young%20people%20hiking%20on%20mountain%20trail%20with%20backpacks%2C%20warm%20sunset%20light%2C%20natural%20green%20landscape%2C%20clean%20minimal%20style%2C%20soft%20warm%20atmosphere%2C%20editorial%20photography%20with%20natural%20textures%20and%20organic%20composition&width=800&height=500&seq=category-outdoor&orientation=landscape',
  },
  {
    id: 'music',
    name: '音乐艺术',
    slug: 'music',
    description: '音乐演出、艺术展览、手工创作，用艺术连接心灵',
    icon: 'ri-music-line',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20young%20people%20playing%20acoustic%20guitar%20in%20cozy%20indoor%20studio%20with%20warm%20lighting%2C%20artistic%20atmosphere%2C%20minimal%20interior%20with%20wooden%20furniture%2C%20soft%20golden%20hour%20light%2C%20editorial%20photography%20style%2C%20warm%20neutral%20tones&width=800&height=500&seq=category-music&orientation=landscape',
  },
  {
    id: 'food',
    name: '美食烹饪',
    slug: 'food',
    description: '美食探店、烹饪课堂、烘焙分享，一起品味美好生活',
    icon: 'ri-restaurant-line',
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20friends%20enjoying%20homemade%20Chinese%20cuisine%20around%20wooden%20table%2C%20warm%20kitchen%20atmosphere%2C%20steaming%20dishes%2C%20natural%20window%20light%2C%20clean%20minimal%20style%2C%20cozy%20gathering%20scene%2C%20editorial%20food%20photography%20with%20soft%20shadows&width=800&height=500&seq=category-food&orientation=landscape',
  },
  {
    id: 'reading',
    name: '读书学习',
    slug: 'reading',
    description: '读书会、知识分享、技能交换，在学习中共同进步',
    icon: 'ri-book-open-line',
    image: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20people%20reading%20and%20discussing%20books%20in%20bright%20modern%20library%20with%20large%20windows%2C%20natural%20daylight%2C%20minimal%20wooden%20bookshelves%2C%20warm%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=500&seq=category-reading&orientation=landscape',
  },
  {
    id: 'gaming',
    name: '游戏电竞',
    slug: 'gaming',
    description: '电竞比赛、桌游聚会、游戏交流，志同道合的玩家社区',
    icon: 'ri-gamepad-line',
    image: 'https://readdy.ai/api/search-image?query=Friends%20playing%20board%20games%20together%20in%20modern%20living%20room%2C%20warm%20evening%20atmosphere%2C%20soft%20lamp%20lighting%2C%20minimal%20interior%20design%2C%20laughing%20and%20enjoying%2C%20cozy%20social%20scene%2C%20editorial%20photography%20style&width=800&height=500&seq=category-gaming&orientation=landscape',
  },
  {
    id: 'travel',
    name: '旅行探险',
    slug: 'travel',
    description: '结伴旅行、城市探索、文化交流，一起看世界的精彩',
    icon: 'ri-flight-takeoff-line',
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20young%20travelers%20exploring%20ancient%20Chinese%20town%20with%20traditional%20architecture%2C%20warm%20afternoon%20sunlight%2C%20narrow%20stone%20streets%2C%20cultural%20heritage%20atmosphere%2C%20clean%20editorial%20style%2C%20soft%20natural%20lighting&width=800&height=500&seq=category-travel&orientation=landscape',
  },
  {
    id: 'photography',
    name: '摄影影像',
    slug: 'photography',
    description: '摄影采风、手机摄影、视频创作，用镜头记录美好瞬间',
    icon: 'ri-camera-line',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20young%20photographers%20taking%20photos%20outdoors%20in%20urban%20park%2C%20golden%20hour%20light%2C%20creative%20atmosphere%2C%20minimal%20aesthetic%2C%20warm%20natural%20tones%2C%20editorial%20photography%20style%20with%20soft%20bokeh%20background&width=800&height=500&seq=category-photography&orientation=landscape',
  },
  {
    id: 'fitness',
    name: '健身运动',
    slug: 'fitness',
    description: '瑜伽冥想、跑步打卡、健身挑战，一起塑造健康生活',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Group%20fitness%20class%20in%20bright%20modern%20studio%20with%20large%20windows%2C%20Chinese%20young%20people%20exercising%20together%2C%20natural%20daylight%2C%20minimal%20interior%2C%20yoga%20mats%20on%20wooden%20floor%2C%20warm%20clean%20atmosphere%2C%20editorial%20style&width=800&height=500&seq=category-fitness&orientation=landscape',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};